import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import styled from "@emotion/styled";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import SimpleCard from "../../../../../../shared/components/SimpleCard";

const ProfessionalFeesCard = () => {
  const {
    PROPERTY_DETAIL: {
      professionalFees,
      principalData: {}
    }
  } = useRealEstateDetailContext();

  return (
    <SimpleCard showBg={false} title="Honorarios profesionales">
      <Content>
        {/* <TextSimple color="blue" size="label" weight="700" font="gotham">
          Total de comisión {professionalFees.guaranteed_commission}%
        </TextSimple> */}

        {professionalFees.total_commission && (
          <TextSimple color="blue" size="medium" weight="500" font="inter">
            Comisión de venta {professionalFees.total_commission} %
          </TextSimple>
        )}
        {professionalFees.lease_commission && (
          <TextSimple color="blue" size="medium" weight="500" font="inter">
            Comisión de {professionalFees.lease_commission}
          </TextSimple>
        )}
      </Content>
    </SimpleCard>
  );
};

export default ProfessionalFeesCard;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -10px;
`;
